import React from 'react';

const ModalBackdrop = ({ onClose, children }) => {
  return (
    <div className="fixed inset-0 z-1000 flex items-center justify-center p-4 bg-background/90 backdrop-blur-md animate-fade-in">
      <div 
        className="absolute inset-0"
        onClick={onClose}
        aria-label="Close modal by clicking backdrop"
      />
      
      <div className="relative w-full max-w-6xl bg-card rounded-3xl shadow-elevation-lg animate-scale-in max-h-[95vh] overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default ModalBackdrop;